import React from "react";

import Slider from "react-slick";
import PlaceCard from "../../common/PlaceCard";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const FastReserve = ({ infoHome }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    rtl: true,
    rows: 1,
    centerMode: true,
    centerPadding: '6%',
    className: "carousel-padding",


    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
      
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        
          
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        
          
        }
      }
    ]
  };
 
  return (
    <div className="container">
      <div className="FastReserve">
        <h3 className="FastReserve-title">رزرو های فوری</h3>
        <div className="FastReserve--slider">
          {infoHome
            ? <Slider {...settings}>
                {
                  infoHome.instant_reserves.map(i =>
                    <PlaceCard
                      key={i.id}
                      img={`${i.thumbnail?.path}`}
                      isfast={true}
                      rate={i.rating_value}
                      info={i.address}
                      title={i.title}
                      cost={i.price}
                      tip={i.special_discount_in_24}
                      code={i.code}
                      slug={i.slug}
           wishlist={i.wishlist}
           id={i.id}
           room={i.rooms_count}
           city={i.city}
           type={i.type}
                    />
                  )}
              </Slider>
            : <div className="container">
                <SkeletonTheme height={500} borderRadius={10}>
                  <div className="grid grid-cols-4 gap-[30px] ">
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                  </div>
                </SkeletonTheme>
              </div>}
        </div>
      </div>
    </div>
  );
};

export default FastReserve;
